import axios from 'axios';
import { BASE as ApiURL } from './endpoints';

const storeScrapperForLead = (store) => {
    return {
        email: store.email,
        mileage: store.mileage,
        motivation: store.purpose,
        region_id: store.location,
        schwacke_car_id: store.schwacke,
        initial_registration: `${store.year}-${store.month}`,

        predicted_price: store.predicted_price,
        price_cut_expensive: store.price_cut_expensive,
        price_cut_fair: store.price_cut_fair,
        price_cut_good: store.price_cut_good,
        price_cut_high: store.price_cut_high,

        extras: store.extras
    }
};

const arrayOfExtras = (extras = []) => {
    if (!extras) return '';

    return extras.reduce((acc, item, index, arr) => {
        return index + 1 < arr.length ? acc += `extras[]=${item}&` : acc += `extras[]=${item}`;
    }, '');
}

const sendLeadApiUrl = (token) => {
    const newLeadEndpoint = '/opt_in/procurement/leads';
    const existingUserEndpoint = '/procurement/leads';
    const leadCreationLink = token ? existingUserEndpoint : newLeadEndpoint;

    return ApiURL + leadCreationLink;
};

export function sendLead(store, token = null) {
    const payload = storeScrapperForLead(store);
    const url = sendLeadApiUrl(token);

    const config = {};
    if (token) { config.headers = { 'X-Auth-Token': token } }

    return axios.post(url, { ...payload }, { ...config });
}

export function sendValuation(store) {
    const { schwacke, mileage, extras, year } = store;
    const url = ApiURL + `/procurement/cars/${schwacke}/valuate?mileage=${mileage}&${arrayOfExtras(extras)}&initial_registration=${year}-01`

    return axios.get(url);
}

export function makeLogin(email, password) {
    const url = ApiURL + '/auth/login';
    return axios.post(url, { email, password });
}



// WEBPACK FOOTER //
// ./src/services/api-helpers.js